<ng-container [ngSwitch]="field.field_name">
      
    @if(sectionName === 'send-document') {
      <app-visibility-field
        *ngSwitchCase="'visibility'"
        [formGroup]="formGroup"
        [documentData]="documentData"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-visibility-field>

      <app-template-roles-field
        *ngSwitchCase="'template_roles'"
        [field]="field"
        [documentData]="documentData">
      </app-template-roles-field>

      <app-contract-control-field
        *ngSwitchCase="'contract_control_multi_sections'"
        [documentData]="documentData"
        (actionEmit)="fieldAction.emit($event)">
      </app-contract-control-field>

      @if(shouldShowDueDateField){
        <app-due-date-field
          *ngSwitchCase="'due_date'"
          [formGroup]="formGroup"
          [isDueDateDisabled]="isDueDateDisabled"
          [disableFlatpickr]="disableFlatpickr"
          [documentData]="documentData"
          (actionEmit)="fieldAction.emit($event)">
        </app-due-date-field>
      }

      <app-status-updated-field
        *ngSwitchCase="'status_updated_at'"
        [field]="field">
      </app-status-updated-field>

      <app-tags-field
        *ngSwitchCase="'tags'"
        [field]="field"
        [formGroup]="formGroup"
        [tags]="tags"
        [hasFullAccess]="hasFullAccess"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-tags-field>
      
      <app-external-chat-field
        *ngSwitchCase="'external_chat'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-external-chat-field>
    }

    @if(documentData?.template_details?.type !== templateType.TEMPLATEDOCUMENT){
      <app-signing-deadline
        *ngSwitchCase="'signing_deadline'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-signing-deadline>
         
      <app-signing-reminder
        *ngSwitchCase="'signing_reminder'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-signing-reminder>

      <app-invitation-message
        *ngSwitchCase="'invitation_message'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-invitation-message>

      <app-confirmation-message
        *ngSwitchCase="'confirmation_message'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-confirmation-message>

      <app-currency-field
        *ngSwitchCase="'currency'"
        [field]="field"
        [formGroup]="formGroup"
        [documentData]="documentData"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-currency-field>
    }
    <app-language-field
      *ngSwitchCase="'language'"
      [field]="field"
      [formGroup]="formGroup"
      [languages]="languages"
      [canEdit]="canEdit"
      (actionEmit)="fieldAction.emit($event)">
    </app-language-field>


    @if('DK' | addonPermission | async){
      <app-document-key-field
        *ngSwitchCase="'document_key'"
        [field]="field"
        [formGroup]="formGroup"
        [documentKeyTypes]="documentKeyTypes"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-document-key-field>
    }

    @if(sectionName === 'edit-template') {
      <app-bcc-settings-field
        *ngSwitchCase="'active_bcc'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-bcc-settings-field>
     
      <app-allow-upload-file-field
        *ngSwitchCase="'allow_upload_file'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-allow-upload-file-field>
      
      <app-sender-confirmation-type-field
        *ngSwitchCase="'sender_confirmation_type'"
        [field]="field"
        [formGroup]="formGroup"
        [canEdit]="canEdit"
        (actionEmit)="fieldAction.emit($event)">
      </app-sender-confirmation-type-field>
    }
    </ng-container>